import React from 'react'
import './QuestionStatus.css'
import Palette from '../Palette/Palette'
import { useTranslation } from 'react-i18next'
import { isInPhoneOrTablet } from '../../utils/common/isInPhoneOrTablet'
const QuestionStatus = (props) => {
    const { t, i18n } = useTranslation()
    let data = props.status
    let answered = 0,
        notAnswered = 0,
        visited = 0,
        markedForReview = 0,
        ansRev = 0,
        notVisited = 0
    if (!props.status.summary) {
        for (let i = 0; i < data.questionList.length; i++) {
            if (data.questionList[i].question.isAnswered) {
                answered++
            }
            if (data.questionList[i].question.isVisited) {
                visited++
            }
            if (
                data.questionList[i].question.isMarkedForReview &&
                !data.questionList[i].question.isAnswered
            ) {
                markedForReview++
            }
            if (
                data.questionList[i].question.isMarkedForReview &&
                data.questionList[i].question.isAnswered
            ) {
                ansRev++
            }
            if (
                !data.questionList[i].question.isAnswered &&
                data.questionList[i].question.isVisited &&
                !data.questionList[i].question.isMarkedForReview
            ) {
                notAnswered++
            }
        }
        notVisited = data.questionList.length - visited
    }

    return (
        <ul className="list-item">
            <li
                className="all"
                style={
                    props.isCloseTestConfimationPopUp ? { display: 'none' } : null
                }
            >
                {t('All Questions')}

                <span className="count">
                    {props.status.summary
                        ? props.status.summary[0].total
                        : data.questionList.length}
                </span>
            </li>
            <li
                style={
                    props.isCloseTestConfimationPopUp && isInPhoneOrTablet()
                        ? { padding: '5px' }
                        : null
                }
            >
                <Palette className={'answered'} name={t('Answered')} />
                <span className="count">
                    {props.status.summary
                        ? props.status.summary[0].answered -
                          props.status.summary[0].answeredAndMarkedForReview
                        : answered - ansRev}
                </span>
            </li>
            <li
                style={
                    props.isCloseTestConfimationPopUp && isInPhoneOrTablet()
                        ? { padding: '5px' }
                        : null
                }
            >
                <Palette className={'not-answered'} name={t('Not Answered')} />
                <span className="count">
                    {props.status.summary
                        ? props.status.summary[0].notanswered
                        : notAnswered}
                </span>
            </li>
            <li
                style={
                    props.isCloseTestConfimationPopUp && isInPhoneOrTablet()
                        ? { padding: '5px' }
                        : null
                }
            >
                <Palette
                    className={'marked-for-review'}
                    name={t('Marked for review')}
                />
                <span className="count">
                    {props.status.summary
                        ? props.status.summary[0].markedForReview
                        : markedForReview}
                </span>
            </li>
            <li
                style={
                    props.isCloseTestConfimationPopUp && isInPhoneOrTablet()
                        ? { padding: '5px' }
                        : null
                }
            >
                <Palette
                    className={'answered-for-review'}
                    name={t('Answered and Marked for Review')}
                />
                <span className="count">
                    {props.status.summary
                        ? props.status.summary[0].answeredAndMarkedForReview
                        : ansRev}
                </span>
            </li>
            <li
                style={
                    props.isCloseTestConfimationPopUp && isInPhoneOrTablet()
                        ? { padding: '5px' }
                        : null
                }
            >
                <Palette className={'not-visited'} name={t('Not Visited')} />
                <span className="count">
                    {props.status.summary
                        ? props.status.summary[0].notvisited
                        : notVisited}
                </span>
            </li>
        </ul>
    )
}

export default QuestionStatus
